module.exports = __webpack_public_path__ + "img/kr-red-card-right-bottom-4.ec6f987.png";